import styled from 'styled-components';

export default styled.div`
  display: inline;
  font-weight: bold;
  font-size: 13px;
`;
